import "./modalNetwork.css"
import React, { useContext, useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom";
import { auth, db } from "../../../../config/firebaseConfig"; // Firebase設定
import { serverTimestamp, where, updateDoc, collection, getDocs, orderBy, addDoc, query, doc } from "firebase/firestore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { logChange } from "../../../../utils/logService";


const ModalNetwork = ({isOpen, onClose, mode, selectedData})=>{
    const navigate = useNavigate();
    const { masterID } = useParams(); // URLのパラメータを取得 (id)
    const [networkName, setNetworkName] = useState();
    const [networkType, setNetworkType] = useState();
    const [uttID, setUttID] = useState();
    const [capacityA, setCapacityA] = useState();
    const [updatedkva, setUpdatedKVA] = useState();
    const [capacityKVA, setCapacityKVA] = useState();
    const [networkSize, setNetworkSize] = useState();
    const [remark1, setRemark1] = useState();
    const [createdAt, setCreatedAt]= useState(()=>{
        return mode==="edit"&& selectedData?.createdAt
        ? selectedData.createdAt //既存データアリの場合はそのまま
        : new Date().toISOString();//新規作成時は現在日時
    });
    const [updatedAt, setUpdatedAt] = useState();
    const [formData, setFormData] = useState({
    });
    const [options, setOptions] = useState();

    const currentProjectID = localStorage.getItem("currentProjectID");
    //編集の場合はformの初期値を表の選択行の値を設置するコード
    useEffect(()=>{
        if(mode ==='edit'&& selectedData){
            // console.log('selectedData kva', selectedData.capacityKVA)
            const updatedFormData={
            // setFormData({
                masterID: selectedData.masterID,
                uttID: selectedData.uttID?? null,
                networkName: selectedData.networkName ?? null,
                networkType: selectedData.networkType ?? null,
                connectedDeviceType: selectedData.connectedDeviceType ?? null,
                IPAddress: selectedData.IPAddress ?? null,
                MacAddress: selectedData.MacAddress ?? null,
                remark1: selectedData.remark1 ?? '',
                createdBy: selectedData.createdBy?? null,
                createdAt: selectedData.createdAt?? null,
                updatedBy: auth.currentUser.displayName ?? null,
                updatedAt: serverTimestamp()?? null,
                deleted: false?? null,
                deletedAt: '',
                deletedBy: '',
                projectID: currentProjectID
            }
        setFormData(updatedFormData);
        // console.log('Updated formData:', updatedFormData);
        }else{
            setFormData({
                masterID: masterID,
                uttID: uttID,
                networkName:  "",
                networkType: "",
                connectedDeviceType: "",
                IPAddress: "",
                MacAddress: "",
                remark1: "",
                createdBy: auth.currentUser.displayName?? null,
                createdAt: serverTimestamp()?? null,
                updatedBy: auth.currentUser.displayName ?? null,
                updatedAt: serverTimestamp()?? null,
                deleted: false?? null,
                projectID: currentProjectID
        });
        }
    }, [mode, selectedData, masterID, onClose])

    useEffect(() => {
        // console.log('新しく書き込まれるformdata:', formData);
    }, [formData]);

    //日時編集
    useEffect(()=>{
        if(mode==="edit"&& selectedData?.createdAt){
            setCreatedAt(selectedData.createdAt);
        }
    },[mode, selectedData]);



    //新しいuttIDを生成(uttID+1になるように)
        useEffect(() => {
            if (mode==='create'){//editの時は動作しない
            const fetchUttID = async () => {
                try {
                    // Firestore クエリ: masterID に一致するデータを取得
                    const q = query(
                        collection(db, "02-1_networkTable"),
                        where("masterID", "==", masterID),
                        where("projectID", "==", currentProjectID)
                    );
                    const querySnapshot = await getDocs(q);
                    // `uttID` の配列を取得
                    const uttIDs = querySnapshot.docs
                        .map(doc => doc.data().uttID)
                        .filter(id => id.startsWith("NW")) // (2) "NW"から始まるものを抽出
                        .map(id => parseInt(id.replace("NW", ""), 10)) // 数値部分を抽出し変換
                        .filter(num => !isNaN(num)); // 数値に変換できたものだけ残す

                    // 最大値を取得して +1
                    const nextNumber = uttIDs.length > 0 ? Math.max(...uttIDs) + 1 : 1;
                    const nextUttID = `NW${String(nextNumber).padStart(3, "0")}`; // 3桁フォーマット
                    setUttID(nextUttID); // `uttID` を更新
                    console.log('nextUTTIDを作りました。', mode, nextUttID, uttID)
                } catch (error) {
                    console.error("uttID の取得に失敗しました:", error);
                }
            };
               fetchUttID();
            }
        }, [isOpen, masterID]);

        useEffect(() => {
            const fetchNetworkOptions = async () => {
            try {
                const colRef = collection(
                db,
                `projects/${currentProjectID}/settings/network/networkTypeOptions`
                );
                const querySnap = await getDocs(colRef);

                const activeOptions = [];
                querySnap.forEach((docSnap) => {
                const data = docSnap.data();
                if (data?.isActive === true) {
                    activeOptions.push(data.name);
                }
                });

                setOptions(activeOptions);
            } catch (error) {
                console.error("FirestoreからのnetworkTypeOptions取得エラー:", error);
            }
            };

            if (currentProjectID) fetchNetworkOptions();
        }, [currentProjectID]);


    // 変更時に入力値をformDataに反映する関数
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData, // 既存のデータを保持
            [name]: value // 変更されたフィールドだけ更新
        })
    );
    // console.log('変更されました。', formData);
    };
    
    //登録処理
    const handleSubmit = async (e) => {
        e.preventDefault();// フォーム送信のデフォルト動作を防ぐ
        try {
            if (mode==='edit') {
                // //　編集モード
                // 🔹 Firestore から masterID に一致するデータを検索
                const q = query(
                    collection(db, "02-1_networkTable"),
                    where("masterID", "==", masterID),
                    where("uttID","==", formData.uttID), // masterID フィールドとuttIDが一致するデータを検索
                    where("projectID", "==", currentProjectID)
                );
                const querySnapshot = await getDocs(q);
                if (!querySnapshot.empty) {

        // ここから↓↓
                const docSnap = querySnapshot.docs[0];
                const docRef = docSnap.ref;
                const existingData = docSnap.data();

                // 🔹 更新データを作成
                const updatedFormData = { ...existingData, ...formData };
                await updateDoc(docRef, updatedFormData);

                // 🔹 フィールド単位で changeLogs に書き込み
                    // 除外するフィールド名の配列。以下のリストに記載されているフィールドは変更履歴に残らない。
                    const excludedFields = ["updatedAt", "createdAt"];
                    for (const key in updatedFormData) {
                        // 除外リストに含まれていればスキップ
                        if (excludedFields.includes(key)) continue;

                        if (updatedFormData[key] !== existingData[key]) { // 変更がある場合のみ
                            await logChange({
                                projectId: currentProjectID,
                                target: `02-1_networkTable/${docRef.id}`,
                                field: key,
                                masterID: updatedFormData.masterID,
                                uttID: updatedFormData.uttID,
                                utilityType: 'ネットワーク',
                                oldValue: existingData[key],
                                newValue: updatedFormData[key],
                                userId: auth.currentUser.uid,
                                userName: auth.currentUser.displayName || "unknown",
                                timestamp: serverTimestamp()
                            });
                        }
                    }


                onClose();
            } else {
                console.error("エラー: 該当のドキュメントが存在しません");
            }


        // ここまで↑↑

            } else {
                // 新規作成モード (追加)
                const newRef = await addDoc(collection(db, "02-1_networkTable"), formData);
                onClose();
            }
        } catch (error) {
            console.error("エラー:", error);
        }
    };

   

    // 電気タイプの選択ハンドラ（例: 電気タイプが変更されたとき）
    const handleNetworkTypeChange = (e) => {
        setNetworkType(e.target.value);
    };

    const handleDelete = async () => {
        if (!selectedData || !selectedData.masterID || !selectedData.uttID) {
            alert("削除対象のデータが見つかりません。");
            return;
        }
        const confirmDelete = window.confirm("本当に削除しますか？");
        if (!confirmDelete) return;
    
        try {
            // Firestoreから `masterID` と `uttID` が一致するデータを検索
            const q = query(
                collection(db, "02-1_networkTable"),
                where("masterID", "==", selectedData.masterID),
                where("uttID", "==", selectedData.uttID),
                where("projectID", "==", currentProjectID)
            );
    
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
                // 最初に一致したドキュメントを取得
                const docRef = querySnapshot.docs[0].ref;
                const existingData = querySnapshot.docs[0].data();
    
                // Firestore のデータを更新（論理削除）
                await updateDoc(docRef, {
                    deleted: true,
                    deletedAt: serverTimestamp(),
                    deletedBy: auth.currentUser.displayName ?? "Unknown"
                });
                // 🔹 変更履歴ログをchangeLogsに作成
                await logChange({
                    projectId: currentProjectID,
                    target: `02-1_networkTable/${docRef.id}`,
                    field: "deleted",
                    masterID: existingData.masterID,
                    uttID: existingData.uttID,
                    utilityType: 'ネットワーク',
                    oldValue: existingData.deleted ?? false,
                    newValue: true,
                    userId: auth.currentUser.uid,
                    userName: auth.currentUser.displayName || "unknown",
                    timestamp: serverTimestamp()
                });

                alert("削除が完了しました。");
                onClose();
            } else {
                alert("該当のデータが見つかりませんでした。");
            }
        } catch (error) {
            console.error("削除に失敗しました:", error);
            alert("削除に失敗しました。");
        }
    };

    if(!isOpen) {
        return null;//モーダルが開かれていないときは表示しない
    }
    return(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="close-btn" onClick={onClose}>×</button>
                <h2 class="title network">{mode==="edit"? "ネットワーク 編集": "ネットワーク 新規作成"}画面</h2>
                {/* 編集時のみ削除ボタン表示 */}
                    {mode === "edit" && (
                        <button onClick={handleDelete} className="delete-btn">
                            <FontAwesomeIcon icon={faTrashAlt} size={40} />削除
                        </button>
                    )}                   
                    <form id="form_Network" onSubmit={handleSubmit}>
                        <div class="Network EditContainer">
                            <button type="submit"> "登録 / 更新"</button>
                            {/* <!-- col1 --> */}
                            <div class="inputContainer">
                            <label for="masterID">マスターID</label>
                            <input
                                type="text"
                                name="masterID"
                                class="inputbox"
                                disabled
                                id="input1"
                                value={formData.masterID}
                                onChange={handleChange}
                            />
                            </div>
                            {/* <!-- col2 --> */}
                            <div class="inputContainer">
                                <label for="ut_id">uttID</label>
                                <input
                                type="text"
                                name="uttID"
                                class="inputbox"
                                disabled
                                id="input2"
                                onChange={handleChange}
                                value ={mode==='edit'?selectedData.uttID: uttID}/>
                                
                            </div>
                            {/* <!-- col3 --> */}
                            <div class="inputContainer">
                                <label for="networkName">名称</label>
                                <input
                                type="text"
                                name="networkName"
                                class="inputbox"
                                id="input3"
                                required
                                value={formData.networkName}
                                onChange={handleChange}/>
                            </div>
                            {/* <!-- col4 --> */}
                            <div class="inputContainer">
                                <label for="connectedDeviceType">接続先機器種</label>
                                <select name="connectedDeviceType" id="input4" class="inputbox"
                                value={formData.connectedDeviceType}
                                onChange={(e)=>{
                                    handleChange(e);
                                }}>
                                    <option value=""></option>
                                    <option value="PLC">PLC</option>
                                    <option value="PC">PC</option>
                                    <option value="アンドン制御盤">アンドン制御盤</option>
                                    <option value="アンドンPC">アンドンPC</option>
                                </select>
                            </div>
                            {/* <!-- col5 --> */}
                            <div className="inputContainer">
                                <label htmlFor="networkType">ネットワーク種</label>
                                <select
                                    name="networkType"
                                    id="networkType"
                                    className="inputbox"
                                    required
                                    value={formData.networkType}
                                    onChange={(e) => handleChange(e)}
                                >
                                    <option value="">選択してください</option>
                                    {options?.map((opt, i) => (
                                    <option key={`network-${i}`} value={opt}>
                                        {opt}
                                    </option>
                                    ))}
                                </select>
                                </div>
                            {/* <!-- col6 --> */}
                            <div class="inputContainer">
                                <label for="IPAddress">IPアドレス</label>
                                <input
                                name="IPAddress"
                                class="inputbox"
                                id="input6"
                                onChange={handleChange}
                                value={formData.IPAddress}
                                />
                            </div>
                            {/* <!-- col7 --> */}
                            <div class="inputContainer">
                                <label for="MacAddress">Macアドレス</label>
                                <input
                                name="MacAddress"
                                class="inputbox"
                                id="input7"
                                onChange={handleChange}
                                value={formData.MacAddress}
                                />
                            </div>
                        </div>        
                        {/* <!-- col8 --> */}
                        <div class="inputContainer remark1">
                            <label for="remark1">備考</label>
                            <textarea name="remark1" id="input8" placeholder="備考等を入力ください。" class="inputbox"
                            value={formData.remark1}
                            onChange={handleChange}></textarea>
                        </div>
                    </form>
            </div>
        </div>    );
};

export default ModalNetwork;